import React, {useContext, useEffect, useLayoutEffect, useState} from "react"
import {useParams} from "react-router-dom"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import Content from "../Content"
import {
    WorkflowContext,
    WORKFLOW_ID_POINTER,
    WORKFLOW_STEP_POINTER,
} from "../../../src/context/WorkflowContextProvider"
import {DataContext} from "../../../src/context/DataContextProvider"
import TomClient from "../../services/tomClient"

const WorkflowRoot = ({workflowId}) => {
    const {stepId} = useParams()
    const {updateData} = useContext(DataContext)
    const {cancelWorkflow, ensureWorkflow, getWorkflowById, isWorkflowLoaded} =
        useContext(WorkflowContext)
    const [container, setContainer] = useState(null)

    useEffect(() => ensureWorkflow(workflowId), [workflowId])

    const workflow = getWorkflowById(workflowId)
    const step = workflow?.steps?.find((entry) => entry.id === stepId) ?? null
    const containerId = step?.containerId

    useEffect(() => {
        if (!containerId) {
            setContainer(null)
            return undefined
        }
        let cancelled = false
        TomClient.getEnrich("/module", {containerId})
            .then((response) => {
                if (!cancelled) setContainer(response?.page ?? null)
            })
            .catch((error) => {
                console.error(
                    `[Workflow] Container "${containerId}" für Step "${stepId}" nicht ladbar`,
                    error,
                )
                if (!cancelled) setContainer(null)
            })
        return () => {
            cancelled = true
        }
    }, [containerId])

    useLayoutEffect(() => {
        updateData(workflowId ?? "", WORKFLOW_ID_POINTER)
        updateData(stepId ?? "", WORKFLOW_STEP_POINTER)
    }, [workflowId, stepId])

    useLayoutEffect(
        () => () => {
            updateData("", WORKFLOW_STEP_POINTER)
            updateData("", WORKFLOW_ID_POINTER)
        },
        [],
    )

    if (!isWorkflowLoaded(workflowId)) return null

    if (!step) {
        console.error(
            `[Workflow] Step "${stepId}" in Workflow "${workflowId}" nicht gefunden.`,
        )
        return null
    }

    if (step.rootType === "FINISH" || !container) return null

    if (step.rootType === "DIALOG") {
        return (
            <Dialog
                open
                onClose={cancelWorkflow}
                maxWidth="sm"
                fullWidth
                aria-labelledby="workflow-dialog-title">
                <DialogTitle id="workflow-dialog-title">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}>
                        <Typography
                            variant="h6"
                            component="span">
                            {container.text}
                        </Typography>
                        <IconButton
                            onClick={cancelWorkflow}
                            edge="end"
                            size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Content key={container.id} child={container} />
                </DialogContent>
            </Dialog>
        )
    }

    return (
        <Box sx={{width: "100%"}}>
            <Content key={container.id} child={container} />
        </Box>
    )
}

export default WorkflowRoot
